import styled from 'styled-components'

interface TableProps {
  columns?: number;
}

export const Table = styled.table<TableProps>`
  display: flex;
  flex-flow: column;
  margin-bottom: ${({ theme }) => theme.spacing.km8};

  tr {
    display: grid;
    grid-template-columns: ${({ columns = 5 }) => `repeat(${columns}, 1fr)`};
    gap: ${({ theme }) => theme.spacing.km4};

    &:first-of-type {
      position: relative;
      margin-bottom: -12px;
    }

    &:last-of-type td {
      border-bottom-right-radius: 20px;
      border-bottom-left-radius: 20px;
      border: initial;
    }
  }
`

export const ContentCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km6};
`
